import { render } from "./BlogCategoryTable.vue?vue&type=template&id=3a64fca8"
import script from "./BlogCategoryTable.vue?vue&type=script&lang=js"
export * from "./BlogCategoryTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__